module.exports = __webpack_public_path__ + "static/img/5-ibm.b3d21a59.png";